<header class="vc-topbar" [class.vc-topbar--sidebar-open]="isSidebarOpen">
  <div class="vc-topbar__left">
    <!-- Hamburger menu button -->
    <button
      class="vc-topbar__hamburger"
      (click)="onToggleSidebar()"
      [attr.aria-expanded]="isSidebarOpen"
      aria-label="Toggle menu"
      pRipple
    >
      <i
        class="fas"
        [class.fa-bars]="!isSidebarOpen"
        [class.fa-times]="isSidebarOpen"
      ></i>
    </button>

    <!-- Page title -->
    <div class="vc-topbar__title">
      @if (pageIcon) {
      <i [class]="pageIcon" class="vc-topbar__title-icon"></i>
      }
      <h1 class="vc-topbar__title-text">{{ pageTitle || "Virtualcenter" }}</h1>
    </div>
  </div>

  <div class="vc-topbar__right">
    @if (!isPatientMode) {
    <button
      type="button"
      class="vc-topbar__action-btn vc-topbar__icon-btn"
      (click)="showSupportReport = true; isNotificationsOpen = false"
      [attr.aria-label]="'SUPPORT.REPORT' | translate"
      [pTooltip]="'SUPPORT.REPORT' | translate"
      tooltipPosition="bottom"
    >
      <i class="fas fa-headset"></i>
    </button>
    <div class="vc-topbar__notifications">
      <button
        class="vc-topbar__action-btn vc-topbar__icon-btn vc-topbar__notification-btn"
        (click)="toggleNotifications()"
        [attr.aria-expanded]="isNotificationsOpen"
        [pTooltip]="'NOTIFICATIONS.TITLE' | translate"
        tooltipPosition="bottom"
      >
        <i class="fas fa-bell"></i>
        @if (unreadCount > 0) {
        <span class="vc-topbar__notification-badge">{{ unreadCount }}</span>
        }
      </button>

      @if (isNotificationsOpen) {
      <div class="vc-topbar__notifications-panel">
        <header>{{ "NOTIFICATIONS.TITLE" | translate }}</header>
        @if (!notifications.length) {
        <div class="vc-topbar__notifications-empty">
          {{ "NOTIFICATIONS.EMPTY" | translate }}
        </div>
        } @else {
        <div class="vc-topbar__notifications-list">
          @for (notification of notifications; track notification.id) {
          <button
            type="button"
            class="vc-topbar__notification-item"
            (click)="openNotification(notification)"
          >
            <strong>{{ notification.title }}</strong>
            <span>{{ notification.message }}</span>
          </button>
          }
        </div>
        }
      </div>
      }
    </div>
    }

    <!-- Language selector -->
    <button
      class="vc-topbar__action-btn"
      (click)="langMenu.toggle($event)"
      pTooltip="Language"
      tooltipPosition="bottom"
    >
      <span class="vc-topbar__lang-flag">{{ getLangFlag() }}</span>
      <span class="vc-topbar__lang-code">{{ currentLang }}</span>
    </button>
    <p-menu
      #langMenu
      [model]="languageItems"
      [popup]="true"
      appendTo="body"
    ></p-menu>

    <!-- User avatar (mobile only, as full info is in sidebar) -->
    <div class="vc-topbar__user" [routerLink]="profileRoute">
      <div class="vc-topbar__user-avatar">
        <i class="fas fa-user"></i>
      </div>
    </div>
  </div>
</header>
@if (showSupportReport && !isPatientMode) {
  <app-support-report-dialog [(visible)]="showSupportReport" (created)="supportCreated($event)" />
}
